<template>
  <CContainer v-if="user" class="pb-3">
    <CRow>
      <CCol>
        <h5 class="mb-4 section-title">Profile Settings</h5>
        <CForm v-if="user" class="mt-2 mb-5">
          <CAlert
            v-if="reqResponse.message"
            class="mt-4"
            :color="reqResponse.type"
            :show="!!reqResponse.message"
          >
            {{ reqResponse.message }}
          </CAlert>
          <VSelect
            v-if="titles"
            v-model="form.title"
            :class="{
              'is-invalid':
                v$.form.title.$error || reqResponse.errors['initials']
            }"
            class="cs-select mb-3 ps__child--consume"
            :options="titles"
            placeholder="Title"
            :clearable="false"
            label="label"
            :reduce="(item) => item.value"
          >
            <template #footer>
              <div
                v-if="v$.form.$error && v$.form.title.required.$invalid"
                class="invalid-feedback"
              >
                This field is required
              </div>
              <div
                v-if="reqResponse.errors['initials']"
                class="invalid-feedback"
              >
                {{ reqResponse.errors["initials"][0] }}
              </div>
            </template>
          </VSelect>

          <div class="form-group">
            <input
              maxlength="35"
              v-model="form.firstName"
              type="text"
              class="form-control"
              :class="{
                'is-invalid':
                  v$.form.firstName.$error || reqResponse.errors['first_name']
              }"
              placeholder="First name (35 characters max)"
            />
            <div
              v-if="v$.form.$error && v$.form.firstName.required.$invalid"
              class="invalid-feedback"
            >
              This field is required
            </div>
            <div
              v-if="reqResponse.errors['first_name']"
              class="invalid-feedback"
            >
              {{ reqResponse.errors["first_name"][0] }}
            </div>
          </div>

          <div class="form-group">
            <input
              maxlength="35"
              v-model="form.lastName"
              type="text"
              class="form-control"
              :class="{
                'is-invalid':
                  v$.form.lastName.$error || reqResponse.errors['last_name']
              }"
              placeholder="Last name (35 characters max)"
            />

            <div
              v-if="v$.form.$error && v$.form.lastName.required.$invalid"
              class="invalid-feedback"
            >
              This field is required
            </div>
            <div
              v-if="reqResponse.errors['last_name']"
              class="invalid-feedback"
            >
              {{ reqResponse.errors["last_name"][0] }}
            </div>
          </div>
          <div v-if="isVisibleAllowAppRequest">
            <p class="mb-2">Allow student appointment requests to you?</p>
            <CCheckBox
              type="radio"
              class="custom-radio standart-style mb-1"
              :custom="true"
              label="Yes"
              :model-value="form.allowAppRequest"
              @update:model-value="form.allowAppRequest = true"
            />
            <CCheckBox
              type="radio"
              class="custom-radio standart-style mb-4"
              :custom="true"
              label="No"
              :model-value="!form.allowAppRequest"
              @update:model-value="form.allowAppRequest = false"
            />
          </div>

          <p class="mb-2">
            Do you want adults and students to be able to create passes to/from
            you?
          </p>
          <CCheckBox
            type="radio"
            class="custom-radio standart-style mb-1"
            :custom="true"
            label="Yes"
            :model-value="form.allowCreatePasses"
            @update:model-value="form.allowCreatePasses = true"
          />
          <CCheckBox
            type="radio"
            class="custom-radio standart-style mb-4"
            :custom="true"
            label="No"
            :model-value="!form.allowCreatePasses"
            @update:model-value="form.allowCreatePasses = false"
          />

          <div class="form-group">
            <input
              v-model="form.pin"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': reqResponse.errors['teacher_pin'] }"
              placeholder="PIN"
            />
            <!-- <div class="invalid-feedback" v-if="v$.form.$error && !v$.form.pin.required">This field is required</div> -->
            <div
              v-if="reqResponse.errors['teacher_pin']"
              class="invalid-feedback"
            >
              {{ reqResponse.errors["teacher_pin"][0] }}
            </div>
          </div>
          <p class="mt-0 mb-4">
            Your PIN needs to be between 4 and 6 letters, numbers or characters
            long (any combination of these, but no spaces).
          </p>

          <div class="form-group form-actions mt-3 text-center">
            <div class="d-inline" @click="submit()">
              <CLoadingButton
                :spinner="isLoading"
                :disabled="isLoading"
                :loading="isLoading"
                class="btn bg-gradient-blue text-white ms-2 mt-2"
              >
                Update
              </CLoadingButton>
            </div>
            <div class="d-sm-inline-block text-center m">
              <router-link
                to="/dashboard"
                class="btn me-2 ms-2 mt-2 p-small bg-gradient-blue reverse"
              >
                <span class="btn bg-white px-4"
                  ><b class="text-graident-blue reverse"
                    >Return to Dashboard</b
                  ></span
                >
              </router-link>
            </div>
          </div>
        </CForm>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import { required } from "@vuelidate/validators"
import useVuelidate from "@vuelidate/core"

export default {
  name: "StudentSettings",
  setup() {
    return { v$: useVuelidate() }
  },
  props: [
    "user",
    "avatar",
    "isActiveAppoinmentModule",
    "activeAppoinmentModuleOptions"
  ],
  data() {
    return {
      form: {
        title: "",
        firstName: "",
        lastName: "",
        newPass: "",
        // createPassAccess: 'Yes',
        allowAppRequest: true,
        allowCreatePasses: true,
        pin: ""
      },
      isLoading: false,
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      },
      titles: [
        { value: null, label: "Title: None" },
        { value: "Mr.", label: "Mr." },
        { value: "Mrs.", label: "Mrs." },
        { value: "MSgt", label: "MSgt" },
        { value: "Ms.", label: "Ms." },
        { value: "Mx.", label: "Mx." },
        { value: "Miss", label: "Miss" },
        { value: "Dr.", label: "Dr." },
        { value: "Principal", label: "Principal" },
        { value: "Assistant Principal", label: "Assistant Principal" },
        { value: "Dean of Students", label: "Dean of Students" },
        { value: "Br.", label: "Br." },
        { value: "Sr.", label: "Sr." },
        { value: "Cpt", label: "Cpt" },
        { value: "Maj", label: "Maj" },
        { value: "Lt Col", label: "Lt Col" },
        { value: "Col", label: "Col" },
        { value: "Sgt", label: "Sgt" },
        { value: "SSG", label: "SSG" },
        { value: "SFC", label: "SFC" },
        { value: "Coach", label: "Coach" },
        { value: "Rabbi", label: "Rabbi" }
      ]
    }
  },
  validations: {
    form: {
      title: {},
      firstName: {
        required
      },
      lastName: {
        required
      }
    }
  },
  computed: {
    isValid() {
      return !this.v$.form.$invalid
    },
    userRole() {
      return this.user ? this.user.role.name : ""
    },
    isVisibleAllowAppRequest() {
      return (
        this.isActiveAppoinmentModule &&
        this.activeAppoinmentModuleOptions &&
        this.activeAppoinmentModuleOptions[this.userRole]
      )
    }
  },
  created() {
    this.form = {
      firstName: this.user.first_name,
      lastName: this.user.last_name,
      title:
        this.user.user_initials && this.user.user_initials !== "null"
          ? this.user.user_initials
          : null,
      allowAppRequest: !!this.user.allow_appointment_requests,
      allowCreatePasses: !!this.user.allow_passes_to_me,
      pin: this.user.pin
    }
  },
  methods: {
    submit() {
      this.resetResponseMessages()
      if (this.isValid) {
        this.isLoading = true
        let data = {
          initials: this.form.title,
          first_name: this.form.firstName,
          last_name: this.form.lastName,
          allow_appointment_requests: this.form.allowAppRequest,
          allow_passes_to_me: this.form.allowCreatePasses,
          is_searchable: this.user.is_searchable
        }
        if (this.form.newPass) {
          data.password = this.form.newPass
        }
        if (this.form.pin) {
          data.teacher_pin = this.form.pin
          data.pin = this.form.pin
        }
        if (this.avatar) {
          data.avatar = this.avatar === "delete" ? null : this.avatar
          if (data.avatar) {
            const formData = new FormData()
            for (const key in data) {
              if (Object.hasOwnProperty.call(data, key)) {
                const element = data[key]
                formData.append(key, element)
              }
            }
            data = formData
          }
        }
        this.$store
          .dispatch("authentication/updateUserProfile", data)
          .then(() => {
            this.v$.$reset()
            this.setSuccessResponse("Successfully updated.")
            this.isLoading = false
            this.$store.dispatch("authentication/getUserDetails", {
              clearCacheEntry: true
            })
            this.$store.dispatch("authentication/getUserSettings", {
              clearCacheEntry: true
            })
          })
          .catch((err) => {
            this.isLoading = false
            const response = err.response.data
            this.setErrorResponse(response.message, response.errors)
          })
      } else {
        this.v$.$touch()
      }
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Someting went wrong!",
        errors: errors ? errors : {}
      }
    }
  }
}
</script>

<style></style>
